define('CustomMerchZone.View',
  [
    'SCView',
    'CustomMerchZone.Model',
    'Product.Model',
    'CustomMerchZone.Collection',
    'CustomMerchZone.Collection.View',
    'Utils',
    'underscore',
    'custom_merch_zone_monster_view.tpl',
    'custom_merch_zone_nabco_view.tpl'
  ],
  function (
    SCViewComponent,
    CustomMerchZoneModel,
    ProductModel,
    CustomMerchZoneCollection,
    CustomMerchZoneCollectionView,
    Utils,
    _,
    TemplateA,
    TemplateB
  ) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function CustomMerchZoneView(options) {
      SCView.call(this);

      this.options = options || {};


      this.initialize = function initialize(options) {
        this.container = options.container;
        this.customMerchConfig = options.environment ? options.environment.getConfig('CustomMerchZone') : {};
        this.customRolesConfig = options.environment ? options.environment.getConfig('roles') : {};
        this.sessionInfo = options.environment ? options.environment.getSession() : {};
        this.isLoggedIn = options.isLoggedIn ? options.isLoggedIn : false;
        this.layout = this.container && this.container.getComponent('Layout');
        this.isLoading = true;
        this.template = this.customMerchConfig && this.customMerchConfig.site === 'NABCO' ? TemplateB : TemplateA;
        this.sliderContainerClass = this.customMerchConfig && this.customMerchConfig.site === 'NABCO' ? '.custom-merch-zone-nabco-container' : '.custom-merch-zone-monster-container';
        this.sliderSlideContainerClass = this.customMerchConfig && this.customMerchConfig.site === 'NABCO' ? '.custom-merch-zone-nabco-slider-slide' : '.custom-merch-zone-monster-slider-slide';
        this.pricingConditionsInformation = {
          profile: options.profile,
          suppliers: options.suppliers,
          manufacturerIds: options.manufacturers,
          pricingGroups: options.pricingGroups
        };
        this.model = new CustomMerchZoneModel();
        var categoryUrl = this.getUrlInfo();
        this.getItems(categoryUrl);
      };

      this.initialize(options);
    }

    CustomMerchZoneView.prototype = Object.create(SCView.prototype);
    CustomMerchZoneView.prototype.constructor = CustomMerchZoneView;

    CustomMerchZoneView.prototype.getUrlInfo = function () {
      if (window.location.hash) {
        var url = window.location.hash;
        url = url.replace('#', '/');
        return url;
      }
      return window.location.pathname;

    };

    CustomMerchZoneView.prototype.getItems = function (actualUrl) {
      var self = this;
      if (self.model && actualUrl) {
        self.model.fetch({
          data: {
            pageUrl: actualUrl
          }
        }).done(function (result) {
          if (result && result.msg === 'SUCCESS') {
            self.itemsInfo = result.itemsInformation;
            self.customerRole = result.role;
            self.merchZoneName = result.merchZoneName;
            self.lookForItemsPrices();
          } else {
            self.showErrorMessage = true;
            self.render();
          }
        });
      }
    };

    CustomMerchZoneView.prototype.lookForItemsPrices = function () {
      var self = this;
      if (self.itemsInfo) {
        var itemsId = _.pluck(self.itemsInfo, 'itemId').join();
        var product = new ProductModel();
        product.get('item').searchApiMasterOptions.include = '';
        product.get('item').searchApiMasterOptions.fieldset = 'custommerchzone';
        product.get('item').fetch({ data: { id: itemsId } }).then(function getProductInfo(data) {
          self.mapItemsInformation(self.itemsInfo, data.items);
        });
      }
    };

    CustomMerchZoneView.prototype.mapItemsInformation = function (backItemInfo, frontItemInfo) {
      var self = this;
      if (backItemInfo && frontItemInfo) {
        _.each(backItemInfo, function (item) {
          var itemInfoFront = _.find(frontItemInfo, function (elem) {
            return String(elem.internalid) === String(item.itemId);
          });

          if (itemInfoFront) {
            item.price = itemInfoFront.onlinecustomerprice_detail ? itemInfoFront.onlinecustomerprice_detail.onlinecustomerprice_formatted : 0;
            item.priceNoFormatted = itemInfoFront.onlinecustomerprice_detail ? itemInfoFront.onlinecustomerprice_detail.onlinecustomerprice : 0;
            item.havePrice = Boolean(item.price);
            item.name = itemInfoFront.itemid;
            item.urlComponent = itemInfoFront.urlcomponent;
            item.isInStock = itemInfoFront.isinstock;
          }
          if (item.image === '') {
            item.image = item.noImage;
          }


          self.pricingConditionsInformation.itemManufacturer = item.itemManufacturer;
          self.pricingConditionsInformation.itemSupplier = item.itemSupplier;

          item.pricingInformation = self.pricingConditionsInformation;
          item.isLoggedIn = self.isLoggedIn;
          item.merchZoneConfig = self.customMerchConfig;
          item.customRolesConfig = self.customRolesConfig;
          item.site = self.customMerchConfig && self.customMerchConfig.site === 'NABCO' && 'NABCO' || 'MONSTER';
          item.customerRole = self.customerRole;
        });
        self.itemsInformation = backItemInfo;
        self.isLoading = false;
        self.render();

        jQuery(document).ready(function () {
          var eachSlideWid = jQuery(self.sliderSlideContainerClass).width();
          self.sliderContainer = jQuery('[data-view="CustomMerchZone.Slides"]').bxSlider({
            auto: true,
            controls: true,
            pager: false,
            minSlides: 1,
            maxSlides: Utils.isDesktopDevice() || Utils.isTabletDevice() ? 4 : 1,
            moveSlides: 1,
            pause: 5000,
            slideMargin: 10,
            shrinkItems: true,
            tickerHover: true,
            slideWidth: Utils.isDesktopDevice() || Utils.isTabletDevice() ? eachSlideWid * 0.20 : eachSlideWid,
            nextText: '<i class="next-icon"></i>',
            prevText: '<i class="prev-icon"></i>'
          });

          if (self.customMerchConfig && self.customMerchConfig.site === 'NABCO' && Utils.isDesktopDevice() || Utils.isTabletDevice()) {
            jQuery('.nabco-bg').css({
              'background-color': '#56A0D3',
              'padding': '15px',
              'margin': 'auto',
              'border-radius': '24px'
            });
          }
        });
      }
    };

    CustomMerchZoneView.prototype.getChildViews = function () {
      return {
        'CustomMerchZone.Slides': function () {
          return new CustomMerchZoneCollectionView({
            collection: new CustomMerchZoneCollection(this.itemsInformation)
          });
        }
      };
    };

    CustomMerchZoneView.prototype.getContext = function () {

      if (this.customMerchConfig && this.customMerchConfig.site === 'NABCO' && !_.isEmpty(this.itemsInformation)) {
        jQuery('.facets-facet-browse-category').css({
          'background-color': 'transparent',
          'background-image': 'none'
        });
        jQuery('.facets-browse-category-heading-main-description').css('display', 'none');
      }

      return {
        itemsInformation: this.itemsInformation,
        isLoadingInfo: this.isLoading,
        showSlider: !_.isEmpty(this.itemsInformation),
        merchZoneName: this.merchZoneName,
        isLoggedIn: this.isLoggedIn
      };
    };

    return CustomMerchZoneView;
  }
);
